import { useNavigate } from 'react-router-dom';
import { useRoastCounter } from '../../hooks/useRoastCounter';
import { Button } from '../ui/button';
import { RoastCounter } from './RoastCounter';
import { RoastingBean } from './RoastingBean';

const WORDS = ['Три', 'дні', 'від', 'ростера'];

export function Hero() {
  const navigate = useNavigate();
  const roast = useRoastCounter();

  return (
    <section className="hero-stripes section-pad relative flex min-h-[78vh] flex-col justify-end border-b border-line">
      <RoastCounter roast={roast} />
      {/* Заголовок і зерно — сусіди в одному ряду (на телефоні зерно над заголовком),
          тож текст ніколи не перекриває зерно, на відміну від абсолютного позиціонування. */}
      <div className="mb-7 flex flex-col-reverse gap-6 md:flex-row md:items-center md:justify-between">
        <h1 className="m-0 flex min-w-0 max-w-[14ch] flex-wrap gap-x-[0.24em] text-[clamp(48px,11vw,150px)] font-extrabold leading-[0.86] tracking-[-0.05em]">
          {WORDS.map((word, index) => (
            <span key={word} className="overflow-hidden">
              <span
                className="inline-block animate-riseIn"
                style={{ animationDelay: `${80 + index * 90}ms` }}
              >
                {word}
              </span>
            </span>
          ))}
        </h1>
        <RoastingBean progress={roast.progress} cracked={roast.cracked} />
      </div>
      {/* На широкому екрані підзаголовок ліворуч, кнопка праворуч; на вузькому кнопка переноситься під текст. */}
      <div
        className="flex animate-fadeUp flex-wrap items-end justify-between gap-8"
        style={{ animationDelay: '420ms' }}
      >
        <p className="m-0 max-w-[46ch] text-[17px] leading-[1.6] text-muted">
          Обсмажуємо невеликими партіями і відправляємо наступного дня.
        </p>
        <Button variant="accent" size="lg" onClick={() => navigate('/catalog')}>
          ОБРАТИ КАВУ →
        </Button>
      </div>
    </section>
  );
}
